document.addEventListener('DOMContentLoaded', ()=> {
  const linkOpenMore = document.querySelectorAll('.link-show');

  linkOpenMore.forEach(element => {
    element.addEventListener('click', (event) => {

      const parent = event.target.closest('.accordion__wrapper');
      parent.querySelector('.accordion__body--hidden').classList.remove('hidden-pd');
      event.target.classList.add('hidden-pd');

    })
  })
})